import { useId, useState } from 'react';

interface Props {
  label: string;
  submitLabel: string;
  busy?: boolean;
  onSubmit(pin: string): void;
}

/** 4-digit numeric PIN entry with large on-screen keys (also accepts typing). */
export function PinPad({ label, submitLabel, busy, onSubmit }: Props) {
  const id = useId();
  const [pin, setPin] = useState('');
  const add = (d: string) => setPin((p) => (p.length < 4 ? p + d : p));

  return (
    <form
      className="pinpad"
      onSubmit={(e) => {
        e.preventDefault();
        if (pin.length === 4) {
          onSubmit(pin);
          setPin('');
        }
      }}
    >
      <label htmlFor={id}>{label}</label>
      <input
        id={id}
        className="pinpad__input"
        type="password"
        inputMode="numeric"
        pattern="\d{4}"
        maxLength={4}
        autoComplete="off"
        value={pin}
        onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 4))}
      />
      <div className="pinpad__dots" aria-hidden="true">
        {[0, 1, 2, 3].map((i) => (
          <span key={i} className={i < pin.length ? 'filled' : ''} />
        ))}
      </div>
      <div className="pinpad__keys">
        {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((d) => (
          <button key={d} type="button" className="key" onClick={() => add(d)}>
            {d}
          </button>
        ))}
        <button type="button" className="key" onClick={() => setPin((p) => p.slice(0, -1))} aria-label="Apagar dígito">
          ←
        </button>
        <button type="button" className="key" onClick={() => add('0')}>
          0
        </button>
        <button type="submit" className="key key--ok" disabled={pin.length !== 4 || busy} aria-label={submitLabel}>
          ✓
        </button>
      </div>
    </form>
  );
}
